import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { Button } from '../Button'
import { ComboInputWrapper, RouteColumn, RouteRow } from '../layout'
import { LocationInput } from '../layout/form/input'
import { CityInput } from '../layout/form/input/CityInput'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { messages } from './messages'

interface Props {
  empty: () => void
  includeNameInAddress: boolean
}

export const MapForm: React.FunctionComponent<Props> = ({ empty, includeNameInAddress }) => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)
  return (
    <>
      <RouteRow columns="2fr 1fr" mobileGridGap="0.5rem">
        <RouteColumn>
          <ComboInputWrapper>
            <LocationInput
              addressLabel={formatMessage(messages.addressLabel)}
              addressName="address"
              cityName="city"
              coordsName="coords"
              zipcodeName="zipcode"
              includeNameInAddress={includeNameInAddress}
            />
            <CityInput label={formatMessage(messages.cityLabel)} name="city" coordsName="coords" />
          </ComboInputWrapper>
        </RouteColumn>
        <RouteColumn>
          <ClearButton
            label={formatMessage(messages.clearLabel)}
            category="cancel"
            maxWidth="100%"
            mobileWidth="100%"
            size="s"
            onClick={() => {
              empty()
            }}
          />
        </RouteColumn>
      </RouteRow>
    </>
  )
}

const ClearButton = styled(Button as any)`
  margin-top: 1.35rem;
  @media (max-width: ${props => props.theme.screenSize.mobile}) {
    margin-top: 0.5rem;
  }
`
